module.exports = __webpack_public_path__ + "static/media/Fashion-and-Model-Photography-in-Bangalore.53b015ea.png";